import React, {useState} from 'react';
import "./User.sass";
import {FiPlusCircle, FiMinusCircle} from 'react-icons/fi';
import Picture from "../../../../components/Picture";
import translateRole from '../../../../utils';

const User = ({user, selected, onSelect}) => {
    const [hover, setHover] = useState(false);

    const title = `${user.firstName} ${user.lastName}`.substr(0, 22);

    return (
        <div className="room uk-flex" onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)} onClick={onSelect}>
            <div className="profile">
                <Picture user={user} />
            </div>
            <div className="text poppins-bold blue-michigan">
                <div className="title poppins-bold blue-michigan">{title}{title.length > 22 && '...'}</div>
            </div>
            <div className="controls poppins-light blue-michigan">
                <div className={`date${selected ? ' selected' : ''} poppins-light blue-michigan`}>@{translateRole(user.level)}</div>
            </div>
            <div className="controls">
                <div className={`button${selected ? ' selected' : ''}`}>
                    {selected ? <FiMinusCircle/> : <FiPlusCircle/>}
                </div>
            </div>
        </div>
    );
}

export default User;
